import {$, Resource, ResponseSerialize} from 'simpli-web-sdk'
import {Cargo} from '@/model/resource/Cargo'
import {PanelUser} from '@/model/resource/PanelUser'
import {AuditReason} from '@/model/resource/AuditReason'
import {CargoAuditNote} from '@/model/resource/CargoAuditNote'

export class CargoAudit extends Resource {
  idAuditPk: number = 0

  conformed: boolean | null = null
  canhotoDate: string | null = null
  creationDate: string | null = null

  @ResponseSerialize(Cargo)
  cargo: Cargo | null = null

  @ResponseSerialize(PanelUser)
  panelUser: PanelUser | null = null

  @ResponseSerialize(AuditReason)
  auditReason: AuditReason | null = null

  @ResponseSerialize(CargoAuditNote)
  cargoAuditNote = new CargoAuditNote()

  get $id() {
    return this.idAuditPk
  }
  set $id(val) {
    this.idAuditPk = val
  }

  get $tag() {
    return String(this.idAuditPk)
  }

  get idPanelUserFk() {
    if (!this.panelUser) return 0
    return this.panelUser.$id
  }

  set idPanelUserFk(val) {
    if (!this.panelUser) this.panelUser = new PanelUser()
    this.panelUser.$id = val
  }

  get idCargoFk() {
    if (!this.cargo) return 0
    return this.cargo.$id
  }

  set idCargoFk(val) {
    if (!this.cargo) this.cargo = new Cargo()
    this.cargo.$id = val
  }

  get idReasonFk() {
    if (!this.auditReason) return 0
    return this.auditReason.$id
  }

  set idReasonFk(val) {
    if (!this.auditReason) this.auditReason = new AuditReason()
    this.auditReason.$id = val
  }

  get conformedTranslated() {
    if (this.conformed === true) {
      return $.t('component.audit.conformed')
    } else if (this.conformed === false) {
      return $.t('component.audit.notConformed')
    }

    return null
  }

  get conformedClass() {
    if (this.conformed === true) {
      return 'it-tag aquamarine'
    } else if (this.conformed === false) {
      return 'it-tag danger'
    }

    return 'it-tag default'
  }
}
